var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScanQrIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.882812,
    width: 41.3828,
    height: 41.3828,
    rx: 5.55469,
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.882812,
    width: 41.3828,
    height: 41.3828,
    rx: 5.55469,
    stroke: "#EFF2F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21381_17420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6359 13.0596H13.5272C13.057 13.0596 12.6758 13.4408 12.6758 13.911V19.0197C12.6758 19.4899 13.057 19.8711 13.5272 19.8711H18.6359C19.1061 19.8711 19.4873 19.4899 19.4873 19.0197V13.911C19.4873 13.4408 19.1061 13.0596 18.6359 13.0596Z",
    fill: "#E4E3F6",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6359 23.2773H13.5272C13.057 23.2773 12.6758 23.6585 12.6758 24.1288V29.2374C12.6758 29.7077 13.057 30.0889 13.5272 30.0889H18.6359C19.1061 30.0889 19.4873 29.7077 19.4873 29.2374V24.1288C19.4873 23.6585 19.1061 23.2773 18.6359 23.2773Z",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8546 13.0596H23.746C23.2757 13.0596 22.8945 13.4408 22.8945 13.911V19.0197C22.8945 19.4899 23.2757 19.8711 23.746 19.8711H28.8546C29.3249 19.8711 29.7061 19.4899 29.7061 19.0197V13.911C29.7061 13.4408 29.3249 13.0596 28.8546 13.0596Z",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8945 23.2773V26.6831",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8945 30.0889H26.3003V23.2773",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3008 24.98H29.7065",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.707 28.3857V30.0886",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21381_17420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2461,
    height: 27.2461,
    fill: "white",
    transform: "translate(7.56836 7.95117)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanQrIcon);
export default __webpack_public_path__ + "static/media/scan_qr_icon.b152d752e4eea7c188776f89e396badd.svg";
export { ForwardRef as ReactComponent };